module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.68ea4734.ttf";